module.exports = __webpack_public_path__ + "img/圆柱形读卡器 (1).969bdeaf.jpg";